export let DuplexerEvent = /*#__PURE__*/function (DuplexerEvent) {
  DuplexerEvent["CHATBOT_STATE_UPDATE"] = "CHATBOT_STATE_UPDATE";
  DuplexerEvent["MESSAGE_READ"] = "MESSAGE_READ";
  DuplexerEvent["URL_CHANGED"] = "URL_CHANGED";
  DuplexerEvent["WIDGET_SESSION_EXPIRED"] = "WIDGET_SESSION_EXPIRED";
  DuplexerEvent["WIDGET_SESSION_CREATED"] = "WIDGET_SESSION_CREATED";
  return DuplexerEvent;
}({});
export const DEFAULT_MESSAGE_READ_DELAY = 4; // 4 sec

export * from './DuplexerSubscriber';
//# sourceMappingURL=index.js.map